import { HtmlContent } from '@components/html-content';
import { IconTextFormatWidget } from '@components/icons/text-format-widget';
import { TextEditor } from '@components/text-editor';
import { getScopedTranslate } from '@locale/translate';
import { getRawTextFromHtml } from '@utils/browser';

import { FieldDropzone } from './field-dropzone';
import { useTextContentActions } from './use-field-actions';

import { conditionsTab } from '../conditions-tab';
import { useFormBuilderContext } from '../context';
import { FieldEdit } from '../field-edit';
import { FieldConfig } from '../field-registry';
import { FieldSidebarLabel } from '../fields-sidebar';

type Config = FieldConfig<'html'>;

const Display: Config['Display'] = ({ field }) => {
  return <HtmlContent html={field.content} />;
};

const FormBuilderHtml: Config['Component'] = ({ field, dragHandle }) => {
  const actions = useFormBuilderContext().store.actions;
  const menuItems = useTextContentActions(field);

  return (
    <FieldDropzone field={field}>
      <FieldEdit
        field={field}
        dragHandle={dragHandle}
        menu={menuItems}
        display={<Display field={field} />}
        edit={
          <TextEditor
            variant="white"
            initialEditorState={field.content}
            onChangeHtml={actions.createChangeHandler(field, 'content')}
          >
            <TextEditor.Toolbar
              disableHeading
              anchorButtonProps={{
                save: t('core.save'),
                addLink: t('addLink'),
                linkToolTip: t('linkToolTip'),
                label: t('label'),
              }}
            />
            <TextEditor.Input stripPastedStyles />
          </TextEditor>
        }
      />
    </FieldDropzone>
  );
};

const { t } = getScopedTranslate({
  en: {
    title: 'Text',
    addLink: 'Add link',
    linkToolTip: 'Select what you want to turn into a hyperlink',
    label: 'Link',
  },
});

export const htmlConfig: Config = {
  kind: 'html',
  title: t('title'),
  group: 'content',
  Display,
  TreeDisplay: ({ field }) => <FieldSidebarLabel label={getRawTextFromHtml(field.content)} />,
  Icon: IconTextFormatWidget,
  Component: FormBuilderHtml,
  propertiesTabs: [conditionsTab],
};
